import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ja_JP',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '45be2b34-ca9d-4fdc-9f71-0eba7a0028ad',
  ''
);
